<template>
    <div class="holder">
        <div class="attributes-scroll">
            <div v-for="article in props.articles" :key="article.id">
                <article-list-entry :article="article" :showAdminControls="false" @open-project-in-modal="project => emit('open-project-in-modal', project)" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IArticle } from '@/interfaces/storageTracking/IArticle.ts';
import ArticleListEntry from '@/components/storageTracking/projectUpdates/ArticleListEntry.vue';
import { IRedactedProjectData } from '@/interfaces/storageTracking/IRedactedProjectData.ts';

const props = defineProps<{ articles: IArticle[] }>();

const emit = defineEmits<{
    'open-project-in-modal': [IRedactedProjectData];
}>();

</script>
<style lang="scss" scoped>

.holder {
    padding: var(--defaultSpacing) 0 0 var(--defaultSpacing);
    .attributes-scroll {
        max-height: 70vh;
        width: 90vw;
        overflow-y: auto;
        padding-right: var(--defaultSpacing);
        .update-dates {
            text-align: right;
            color: var(--lcpGrapefruit);
            border-bottom:  1px solid var(--lcpGrapefruit);
        }
    }
}
</style>
